import { render, staticRenderFns } from "./HotspotBlock.vue?vue&type=template&id=6db2687e&"
import script from "./HotspotBlock.vue?vue&type=script&lang=js&"
export * from "./HotspotBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports